<template>
<div id="secure">
    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <div class="section" style="padding-left: 0px !important;">
                
                <loading :active.sync="isLoading" 
                    :can-cancel="false" 
                    :is-full-page="fullPage">
                </loading>

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">{{ currentYear }} Timesheet Log for {{ name }}</p>
                    </div>
                    <div class="card-content">
                            <div class="columns" style="margin-bottom: 3px; clear: both; width: 950px; " v-for="calendar in 12" :key="calendar">
                                
                           
                                    <div class="column is-1" style="margin-right: 10px;">
                                    {{ monthName(calendar) }}:
                                    </div>
                                    
                                    <div class="column is-11" v-if="calendar == 1">
                                        <div class="vertical-holder" v-for="data in decemberAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11"  v-if="calendar == 2">
                                        <div class="vertical-holder" v-for="data in novemberAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 3">
                                        <div class="vertical-holder" v-for="data in octoberAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 4">
                                        <div class="vertical-holder" v-for="data in septemberAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11"  v-if="calendar == 5">
                                        <div class="vertical-holder" v-for="data in augustAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 6">
                                        <div class="vertical-holder" v-for="data in julyAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 7">
                                        <div class="vertical-holder" v-for="data in juneAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 8">
                                        <div class="vertical-holder" v-for="data in mayAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11"  v-if="calendar == 9">
                                        <div class="vertical-holder" v-for="data in aprilAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11"  v-if="calendar == 10">
                                        <div class="vertical-holder" v-for="data in marchAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 11">
                                        <div class="vertical-holder" v-for="data in februaryAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>

                                    <div class="column is-11" v-if="calendar == 12">
                                        <div class="vertical-holder" v-for="data in januaryAttendanceList" :key="data.checkInDay" style="margin-right: 1px;">
                                            <div class="absent" v-show="!data.checkIn">
                                                <div class="image-holder"></div>
                                                <div class="date-holder">
                                                    <b-tooltip label="Didn't check in" position="is-bottom" >
                                                        <span class="tag is-light">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>
                                            <div class="checked-in" v-show="data.checkIn">
                                                <div class="image-holder"><img v-bind:src="data.photoImage" class="checkin-image" v-on:click="displayFullImage(data.photoImage)"></div>
                                                <div class="date-holder">                                                
                                                    <b-tooltip :label="showCheckInTime(data.checkInTime,data.checkOutTime,data.checkInDay,data.checkInMonth,data.checkInDayOfWeek)" v-bind="data.checkInTime" position="is-bottom" >
                                                        <span class="tag is-success">{{ data.checkInDay }}</span>
                                                    </b-tooltip>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
                <br />

            </div>
        </div>
    </section>
</div>
</template>

<script>
import SideMenu from '../../SideMenu'
import axios from 'axios'

// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'AttendanceMain',
    components: {
        SideMenu,
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            haveData: false,
            userID: '',
            name: '',
            currentMonth: 1,
            currentYear: '',
            photoImage: '',
            getAttendanceList: [],
            tempAttendance: [],
            tempAttendanceList: [],
            yearlyAttendanceList: [],
            januaryAttendanceListTemp: [],
            februaryAttendanceListTemp: [],
            marchAttendanceListTemp: [],
            aprilAttendanceListTemp: [],
            mayAttendanceListTemp: [],
            juneAttendanceListTemp: [],
            julyAttendanceListTemp: [],
            augustAttendanceListTemp: [],
            septemberAttendanceListTemp: [],
            octoberAttendanceListTemp: [],
            novemberAttendanceListTemp: [],
            decemberAttendanceListTemp: [],
            januaryAttendanceList: [],
            februaryAttendanceList: [],
            marchAttendanceList: [],
            aprilAttendanceList: [],
            mayAttendanceList: [],
            juneAttendanceList: [],
            julyAttendanceList: [],
            augustAttendanceList: [],
            septemberAttendanceList: [],
            octoberAttendanceList: [],
            novemberAttendanceList: [],
            decemberAttendanceList: [],
            displayAttendanceList: {
                checkIn: false,
                checkInDate: '',
                checkInDay: '',
                checkInMonth: '',
                checkInYear: '',
                checkInTime: '',
                photoImage: '',
            }
        }
    },
    beforeMount() {
        this.$emit("authenticated", true)
        console.log('before mount in AddKelas')
        console.log("tokennn? " + localStorage.getItem('jwtToken'))
        console.log("email? " + localStorage.getItem('email'))
        console.log("sessionID? " + localStorage.getItem('sessionID'))
    },
    created() {

        this.userID = this.$store.getters.getUserID;
        this.name = this.$store.getters.getName

        if (this.userID.trim.length < 1){
            this.userID = localStorage.getItem('Attendance_DataList_userID')
        }
        if (this.name.trim.length < 1){
            this.name = localStorage.getItem('Attendance_DataList_name')
        }
        var currentDate = new Date();
        var month = currentDate.getMonth() + 1;  //since month starts at 0.. january is 0!
        var dayOfWeek = currentDate.getDay();
        this.currentMonth = month;
        this.currentYear = currentDate.getFullYear();

        this.getData();
    },
    mounted(){
        this.$root.$emit('activeSideMenu',"StaffAttendanceDetails") 
    },
    methods: {
        displayData(calendar){
            if (calendar == 1){
                if (this.decemberAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 2){
                if (this.novemberAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 3){
                if (this.octoberAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 4){
                if (this.septemberAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 5){
                if (this.augustAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 6){
                if (this.julyAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 7){
                if (this.juneAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 8){
                if (this.mayAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 9){
                if (this.aprilAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 10){
                if (this.marchAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else if (calendar == 11){
                if (this.februaryAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }else{
                if (this.januaryAttendanceList.length > 0){
                    return true;
                }else{
                    return false;
                }
            }
        },
        showCheckInTime(checkInTime,checkOutTime,checkInDay,checkInMonth,checkInDayOfWeek){
            var dayOfWeekDisplay = "";
            if ((checkInDayOfWeek != null) && (checkInDayOfWeek.length > 3)){
                dayOfWeekDisplay = checkInDayOfWeek + ", ";
            }

            var checkInOut = "";
            if ((checkOutTime != null) && (checkOutTime.length > 3)){
                checkInOut =  "checked-in at " + checkInTime + ", checked-out at " + checkOutTime
            }else{
                checkInOut = "checked-in at " + checkInTime
            }

            var checkInMonthActual = 1; //since the passed checkInMonth is calculated in reverse (from 12 to 1)

            switch (checkInMonth){
                case 1:
                    checkInMonthActual = 12;
                    break;
                case 2:
                    checkInMonthActual = 11;
                    break;
                case 3:
                    checkInMonthActual = 10;
                    break;
                case 4:
                    checkInMonthActual = 9;
                    break;
                case 5:
                    checkInMonthActual = 8;
                    break;
                case 6:
                    checkInMonthActual = 7;
                    break;
                case 7:
                    checkInMonthActual = 6;
                    break;
                case 8:
                    checkInMonthActual = 5;
                    break;
                case 9:
                    checkInMonthActual = 4;
                    break;
                case 10:
                    checkInMonthActual = 3;
                    break;
                case 11:
                    checkInMonthActual = 2;
                    break;
                case 12:
                    checkInMonthActual = 1;
                    break;
                default:
                    checkInMonthActual = 1;

            }

            checkInOut = dayOfWeekDisplay + checkInDay + " " + this.monthName(checkInMonthActual) + ", " + checkInOut;

            return checkInOut;
        },
        displayFullImage(image){
            console.log("displayFullImage: " + image)
            window.open(image)
        },
        displayImage(image){
            console.log("displayImage: " + image)
            return image;
        },
        isDataAvailable(month,day){
            if (month < 10){
                month = "0" + month;
            }
            if (day < 10){
                day = "0" + day;
            }
            console.log("imin 128 is data available")
            // //imin sini cek if attendanceList ada data utk the particular month & day
            // for (var i = 0; i < this.attendanceList.length; i++){
            //     console.log("imin 130 berapa: " + i)
            //     if ((this.currentYear == this.attendanceList[i].checkInYear) && (month == this.attendanceList[i].checkInMonth) && (day == this.attendanceList[i].checkInDay)){
            //         console.log("ade " + this.attendanceList[i].checkInYear + " " + this.attendanceList[i].checkInMonth + " " + this.attendanceList[i].checkInDay)
            //         //this.haveData = true; //imin sini menyebabkan infinite loop hmm
            //         // this.checkInTime = this.attendanceList[i].checkInTime;
            //     }else{
            //         this.haveData = false;
            //         //console.log("taadee")
            //     }
            // }
        },
        daysInMonth(month){
            switch(month){
                case 1: case 3: case 5: case 7: case 8: case 10: case 12:
                    return 31;
                    break;
                case 2:
                    return 29;
                    break;
                case 4: case 6: case 9: case 11:
                    return 30;
                    break;
                default:
                    return 30;
                    break;
            }
        },
        monthName(month){
            switch(month){
                case 12:
                    return "January";
                    break;
                case 11:
                    return "February";
                    break;
                case 10:
                    return "March";
                    break;
                case 9:
                    return "April";
                    break;
                case 8:
                    return "May";
                    break;
                case 7:
                    return "June";
                    break;
                case 6:
                    return "July";
                    break;
                case 5:
                    return "August";
                    break;
                case 4:
                    return "September";
                    break;
                case 3:
                    return "October";
                    break;
                case 2:
                    return "November";
                    break;
                case 1:
                    return "December";
                    break;
                default:
                    return "January";
                    break;
            }
        },
        getData() {

            //we need to declare this let self below because this. inside post method refers to axios object, not Vue's
            //https://stackoverflow.com/questions/49468509/using-axios-and-vue-to-fetch-api-data-returning-undefined
            this.isLoading = true;
            let self = this;
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            //axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/teachers/attendance', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        show: 'overall',
                        year: this.currentYear,
                        userID: this.userID,
                    }
                })
                .then(response => {
                    self.getAttendanceList = response.data
                    console.log("len: " + self.getAttendanceList.length)
                    //imin let's do all the processing here
                    for (var h = 12; h > 0; h--){
                        //firstly let's go through the month first
                        for (var g = 0; g < self.getAttendanceList.length; g++){
                            if (h == self.getAttendanceList[g].checkInMonth){
                                console.log("556 h: " + h)
                                if (h == 12){
                                    self.decemberAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 11){
                                    self.novemberAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 10){
                                    self.octoberAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 9){
                                    self.septemberAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 8){
                                    self.augustAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 7){
                                    self.julyAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 6){
                                    self.juneAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 5){
                                    self.mayAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 4){
                                    self.aprilAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 3){
                                    self.marchAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 2){
                                    self.februaryAttendanceListTemp.push(self.getAttendanceList[g])
                                }else if (h == 1){
                                    self.januaryAttendanceListTemp.push(self.getAttendanceList[g])
                                }else{
                                    console.log("should not reach here actually hoho")
                                    self.januaryAttendanceListTemp.push(self.getAttendanceList[g])
                                }
                                
                                self.getAttendanceList.splice(g,1);
                                g = g - 1;  //need to decrement g since splice above will reduce the count of the index
                                //self.getAttendanceList.splice(g,0)
                            }else{
                                console.log("281 else: " + h)
                            }
                        }
                    }

                     console.log("imin jan: ")
                     console.log(self.januaryAttendanceListTemp)
                     console.log("imin feb: ")
                     console.log(self.februaryAttendanceListTemp)
                    //2nd processing
                    for (var h = 12; h > 0; h--){
                        if (h == 12){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.decemberAttendanceListTemp.length; j++){                                    
                                    if (k == self.decemberAttendanceListTemp[j].checkInDay){
                                        console.log("dec yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.decemberAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.decemberAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.decemberAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.decemberAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.decemberAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.decemberAttendanceListTemp[j].image
                                        };
                                        self.decemberAttendanceList.push(myData);
                                        self.decemberAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.decemberAttendanceList.push(myData);
                                }
                                //self.decemberAttendanceList[0] = self.displayAttendanceList;
                            }

                        }else if (h == 11){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.novemberAttendanceListTemp.length; j++){                                    
                                    if (k == self.novemberAttendanceListTemp[j].checkInDay){
                                        console.log("nov yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.novemberAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.novemberAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.novemberAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.novemberAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.novemberAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.novemberAttendanceListTemp[j].image
                                        };
                                        self.novemberAttendanceList.push(myData);
                                        self.novemberAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.novemberAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 10){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.octoberAttendanceListTemp.length; j++){                                    
                                    if (k == self.octoberAttendanceListTemp[j].checkInDay){
                                        console.log("october yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.octoberAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.octoberAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.octoberAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.octoberAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.octoberAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.octoberAttendanceListTemp[j].image
                                        };
                                        self.octoberAttendanceList.push(myData);
                                        self.octoberAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.octoberAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 9){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.septemberAttendanceListTemp.length; j++){                                    
                                    if (k == self.septemberAttendanceListTemp[j].checkInDay){
                                        console.log("september yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.septemberAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.septemberAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.septemberAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.septemberAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.septemberAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.septemberAttendanceListTemp[j].image
                                        };
                                        self.septemberAttendanceList.push(myData);
                                        self.septemberAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.septemberAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 8){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.augustAttendanceListTemp.length; j++){                                    
                                    if (k == self.augustAttendanceListTemp[j].checkInDay){
                                        console.log("august yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.augustAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.augustAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.augustAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.augustAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.augustAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.augustAttendanceListTemp[j].image
                                        };
                                        self.augustAttendanceList.push(myData);
                                        self.augustAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.augustAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 7){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.julyAttendanceListTemp.length; j++){                                    
                                    if (k == self.julyAttendanceListTemp[j].checkInDay){
                                        console.log("july yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.julytAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.julytAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.julyAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.julyAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.julyAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.julyAttendanceListTemp[j].image
                                        };
                                        self.julyAttendanceList.push(myData);
                                        self.julyAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.julyAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 6){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.juneAttendanceListTemp.length; j++){                                    
                                    if (k == self.juneAttendanceListTemp[j].checkInDay){
                                        console.log("june yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.juneAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.juneAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.juneAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.juneAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.juneAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.juneAttendanceListTemp[j].image
                                        };
                                        self.juneAttendanceList.push(myData);
                                        self.juneAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.juneAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 5){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.mayAttendanceListTemp.length; j++){                                    
                                    if (k == self.mayAttendanceListTemp[j].checkInDay){
                                        console.log("may yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.mayAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.mayAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.mayAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.mayAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.mayAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.mayAttendanceListTemp[j].image
                                        };
                                        self.mayAttendanceList.push(myData);
                                        self.mayAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.mayAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 4){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.aprilAttendanceListTemp.length; j++){                                    
                                    if (k == self.aprilAttendanceListTemp[j].checkInDay){
                                        console.log("april yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.aprilAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.aprilAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.aprilAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.aprilAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.aprilAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.aprilAttendanceListTemp[j].image
                                        };
                                        self.aprilAttendanceList.push(myData);
                                        self.aprilAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.aprilAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 3){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.marchAttendanceListTemp.length; j++){                                    
                                    if (k == self.marchAttendanceListTemp[j].checkInDay){
                                        console.log("march yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.marchAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.marchAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.marchAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.marchAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.marchAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.marchAttendanceListTemp[j].image
                                        };
                                        self.marchAttendanceList.push(myData);
                                        self.marchAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.marchAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 2){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.februaryAttendanceListTemp.length; j++){                                    
                                    if (k == self.februaryAttendanceListTemp[j].checkInDay){
                                        console.log("february yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.februaryAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.februaryAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.februaryAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.februaryAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.februaryAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.februaryAttendanceListTemp[j].image
                                        };
                                        self.februaryAttendanceList.push(myData);
                                        self.februaryAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.februaryAttendanceList.push(myData);
                                }
                            }
                        }else if (h == 1){
                            for (var i = 1; i <= self.daysInMonth(h); i++){
                                var k = i;
                                if (k < 10){
                                    k = '0' + k;
                                }
                                var dataFound = false;
                                for (var j = 0; j < self.januaryAttendanceListTemp.length; j++){                                    
                                    if (k == self.januaryAttendanceListTemp[j].checkInDay){
                                        console.log("january yay ade")
                                        var myData = {
                                            checkIn: true,
                                            checkInDay: k,
                                            checkInDayOfWeek: self.januaryAttendanceListTemp[j].checkInDayOfWeek,
                                            checkInMonth: self.januaryAttendanceListTemp[j].checkInMonth,
                                            checkInYear: self.januaryAttendanceListTemp[j].checkInYear,
                                            checkInTime: self.januaryAttendanceListTemp[j].checkInTime,
                                            checkOutTime: self.januaryAttendanceListTemp[j].checkOutTime,
                                            photoImage: process.env.MY_URL + "/public/attendance?image=" + self.januaryAttendanceListTemp[j].image
                                        };
                                        self.januaryAttendanceList.push(myData);
                                        self.januaryAttendanceListTemp.splice(j,1)
                                        j = j - 1;  //need to decrement g since splice above will reduce the count of the index
                                        dataFound = true;
                                    }
                                    if (dataFound == true){
                                        break;  //out from this for loop
                                    }
                                }
                                if (dataFound == false){
                                    var myData = {
                                        checkIn: false,
                                        checkInDay: k,
                                        checkInMonth: h,
                                        checkInYear: this.currentYear,
                                        checkInTime: '',
                                        checkOutTime: '',
                                        photoImage: ''
                                    };
                                    self.januaryAttendanceList.push(myData);
                                }
                            }
                        }

                        this.isLoading = false
                    }
                    console.log("dec: ")
                    console.log(self.decemberAttendanceList)
                })
                .catch(e => {
                    console.log(e)
                    this.isLoading = false
                })
        },

    }
}
</script>
<style lang="css" scoped>
    .checkin-image{
        width: 25px;
        height: 25px;
    }
    .vertical-holder{
        float: left;
    }
    .checked-in{
        border: 1px solid #23d160;
        border-radius: 5px;
    }
    .absent{
        border: 1px solid #CCC;
        border-radius: 5px;
    }
    .image-holder{
        text-align: center;
        width: 25px;
        height: 25px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .date-holder{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/Staff/Attendance/Details.vue